// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-upload-create-choices-group-dialog{overflow-y:auto}.menu-upload-create-choices-group-dialog input,.menu-upload-create-choices-group-dialog label{color:#5d5d5d;font-size:12px}.menu-upload-create-choices-group-dialog .v-text-field--outlined fieldset{border:3px solid #cdcdcd}.menu-upload-create-choices-group-dialog .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg{background-color:#eaeaea!important;color:#000!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
